import { envWithDefault } from "utils/env";

const appConfig = {
  showAnalyticsLog: () => {
    return envWithDefault("REACT_APP_SEGMENT_SHOW_ANALYTICS_LOG") === "true";
  },
};

export default appConfig;
